import { useEffect, useState } from 'react';

/** Khổ rộng (≥ 1800, như các board `-1920`): cột phải của màn mở sẵn và cố định. */
export function useWide(): boolean {
  const q = '(min-width: 1800px)';
  const [w, setW] = useState(() => typeof window !== 'undefined' && window.matchMedia(q).matches);
  useEffect(() => {
    const m = window.matchMedia(q);
    const on = () => setW(m.matches);
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, []);
  return w;
}
